import $ from "jquery";
import A11yUtils from "@core/base/scripts/utils/a11y-utils.js";
import whatInput from "what-input";

export default class CdgMember {
  constructor(container) {
    this.$container = $(container);
    this.$btn = this.$container.find(".cdg-member__opener");
    this.$body = this.$container.find(".cdg-member__body");
    this.isOpen = false;
  }
  init() {
    this.$btn.on("click", () => {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
  }
  open() {
    this.isOpen = true;
    this.$body.slideDown();
    this.$container.removeClass("collapsed");
    this.$btn.attr("aria-expanded", "true");
    this.setFirstFocus();
  }
  close() {
    this.isOpen = false;
    this.$body.slideUp();
    this.$container.addClass("collapsed");
    this.$btn.attr("aria-expanded", "false");
  }
  setFirstFocus() {
    const $focusables = this.$body.find(A11yUtils.FOCUSABLES);
    if ($focusables.length > 0 && whatInput.ask() === "keyboard") {
      setTimeout(() => {
        $focusables[0].focus();
      }, 10);
    }
  }
}
